import { SeatLabelsGenerator } from '../../utils/seat-labels-generator';
import { getRows, getSeatsAmount } from './utils';
export var useMultiRow = function (_a) {
    var definition = _a.definition, svgViewBox = _a.svgViewBox;
    var height = definition.height, rowsSequence = definition.rowsSequence, rowsStartAt = definition.rowsStartAt, rowsReverseDirection = definition.rowsReverseDirection, spacingBetweenRows = definition.spacingBetweenRows;
    var rowsAmount = getSeatsAmount(height, spacingBetweenRows);
    var rowsGenerator = SeatLabelsGenerator({
        sequence: rowsSequence,
        startAt: rowsStartAt,
        reverseDirection: rowsReverseDirection,
        capacity: rowsAmount,
    });
    var rows = getRows({
        definition: definition,
        rowLabelGenerator: rowsGenerator,
        svgViewBox: svgViewBox,
    });
    return { rows: rows };
};
//# sourceMappingURL=use-multi-row.js.map